import { useState } from "react";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useSnackbar } from "@sagecentral/core-ui";
import { ICloneWorkItemPayload } from "models/work-items/clone/ICloneWorkItemPayload";
import { useFeatureEnabled } from "hooks/shared";

type PostAddSignature = (data: any) => void;
type CloneWorkItemSignature = (payload: ICloneWorkItemPayload) => Promise<boolean>;

type UseCloneWorkItemResult = [
    CloneWorkItemSignature,
    boolean
];

type UseCloneWorkItemSignature = (onAdded?: PostAddSignature, onError?: OnErrorEventHandler) => UseCloneWorkItemResult;

const useCloneWorkItem: UseCloneWorkItemSignature = (onAdded, onError) => {    
    const { displaySnackbar } = useSnackbar();
    const [ working, setWorking ] = useState<boolean>(false); 
    const [ enableCloneV3 ] = useFeatureEnabled('clone-v3');
    const user = useCurrentUser();
    const fetcher = useCentralApi(user, false);

    const cloneWorkItem = async (payload: ICloneWorkItemPayload) => {        
        if (user && user.id_token && payload) {
            setWorking(true);
            try {
                let failed = false;
                
                    let formData = new FormData();
                    formData.append('workItemId', payload.workItemId?.toString());
                    payload.copies.forEach(copy => formData.append('Copies', copy));
                    const version = enableCloneV3 ? 'v3' : 'v2'

                    const resp = await fetcher(`/api/${version}/workitems/clone`, {
                        method: 'POST',
                        body: formData
                    });

                    if (!resp.ok) {
                        failed = true;
                    }
                    
                if (failed) {
                    displaySnackbar?.("error", "We couldn't create the clone(s). Please try again");
                } else {
                    displaySnackbar?.("success", "Success! Clone(s) are being created.");
                }
                
                return !failed;
            } catch (err) {
                displaySnackbar?.("error", "We couldn't upload the attachment. Please try again")
            } finally {                    
                setWorking(false);
            }
        }

        return false;
    };

    return [
        cloneWorkItem,
        working
    ];
};

export default useCloneWorkItem;